import { Box, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatConversationTimestamp } from '@/shared/utils/formatters';
import { Message } from '../types/messages.types';

interface MessageBubbleProps {
  message: Message;
  isSent: boolean;
}

export function MessageBubble({ message, isSent }: MessageBubbleProps) {
  const { t, i18n } = useTranslation();

  const timestamp = formatConversationTimestamp(
    message.createdAt,
    i18n.language === 'en' ? 'en-US' : 'fr-FR',
    t('messages.yesterday')
  );

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: isSent ? 'flex-end' : 'flex-start',
        mb: 2,
        px: 2,
      }}
      data-testid={`message-bubble-${message.id}`}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: '75%',
          px: 2,
          py: 1.5,
          bgcolor: isSent ? 'primary.main' : 'grey.100',
          color: isSent ? 'white' : 'text.primary',
          borderRadius: isSent ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
        }}
      >
        <Typography
          variant="body1"
          sx={{
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap',
            color: isSent ? 'white' : 'text.primary',
          }}
        >
          {message.body}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            display: 'block',
            mt: 0.5,
            color: isSent ? 'rgba(255, 255, 255, 0.7)' : 'text.secondary',
            fontSize: '0.75rem',
          }}
        >
          {timestamp}
        </Typography>
      </Paper>
    </Box>
  );
}
